import { Component, Input, Optional } from '@angular/core';
import { AbstractControl, ControlContainer, Validators } from '@angular/forms';
import { CustomValidators } from '../../customvalidators/custom-validators.class';

@Component({
    selector: 'app-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss']
})
export class LabelComponent {

    @Input()
    controlName!: string;

    formControl: AbstractControl | null | undefined

    @Input()
    info!: boolean;

    @Input('class')
    classValue!: string;

    @Input()
    forceRequired: boolean = false;

    constructor(@Optional() private controlContainer: ControlContainer) {
    }

    ngOnInit() {
        if (this.controlContainer) {
            this.formControl = this.controlContainer.control?.get(this.controlName);
        }
    }

    get required(): boolean {
        var aa = this.formControl?.hasValidator(Validators.required) === true;
        var ab = this.formControl?.hasValidator(CustomValidators.selectRequired) === true;
        var ac = this.formControl?.hasValidator(Validators.requiredTrue) === true;

        var a = this.forceRequired ||
            this.formControl?.hasValidator(Validators.required) === true ||
            this.formControl?.hasValidator(CustomValidators.selectRequired) === true ||
            this.formControl?.hasValidator(Validators.requiredTrue) === true;

        return a;
    }
}
